import { Box, MenuItem, Select, Typography, styled } from '@mui/material';
import { IField, IFieldOption } from '../../../models/form/form';
interface IFieldProps {
    field: IField;
}

const SelectField = ({ field }: IFieldProps) => {

    return (
        <Box sx={{ width: "100%" }}>
            <Box marginBottom={1}>
                <Typography display="inline">{field.text.trim()}</Typography>
                {field.required && <Typography display="inline" color="error"> *</Typography>}
            </Box>
            <Select
                value={[]}
                required={field.required}
                fullWidth
                multiple={field.multiselect}
            >
                {field.options.map((option: IFieldOption | string) => (
                    <MenuItem sx={{ whiteSpace: "normal" }} key={`option_${(option as IFieldOption).value}`} value={(option as IFieldOption).id}>
                        {(option as IFieldOption).value}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};

export default SelectField;
